export default __webpack_public_path__ + "static/media/carousel5.6f713b6f.png";